import React from 'react';
import './App.css';
import Navbar from './components/navbar';
import { BrowserRouter as Router, Routes, Route }
	from 'react-router-dom';
//import Home from './pages';
import Home from './pages/index2';
import About from './pages/about';
import Admin from './pages/admin3';
import Contact from './pages/contact';
import Tree_Trimming from './pages/tree_trimming';
import Tree_Removal from './pages/tree_removal';
import Stump_Removal from './pages/stump_removal';
import Debris_Hauling from './pages/debris_hauling';
import Reviews from './pages/reviews'
import { PiPhoneCallBold } from "react-icons/pi";

function App() {
	return (
		<Router>
			<Navbar />
			<Routes>
				<Route exact path='/' element={<Home />} />
				<Route path='/about' element={<About />} />
				<Route path='/contact' element={<Contact />} />
        		<Route path='/tree_trimming' element={<Tree_Trimming />} />
        		<Route path='/tree_removal' element={<Tree_Removal />} />
        		<Route path='/stump_removal' element={<Stump_Removal />} />
        		<Route path='/debris_hauling' element={<Debris_Hauling />} />
        		<Route path='/reviews' element={<Reviews />} />
        		<Route path='/admin' element={<Admin />} />
			</Routes>
      <div className='contact_app' onClick={() => window.location.href = 'tel:941-879-8853'}>
        <div className='circle_icon_contact_app'><PiPhoneCallBold /></div>
      </div>
		</Router>
	);
}

export default App;


